// composables/useWhatsappAttributes.js
import { ref, computed } from 'vue';

export function useWhatsappAttributes() {
  const attributesWhatsapp = ref([
    /* --- WhatsApp --- */
    {
      id: 1,
      attributeDisplayName: "Rejeitar todas as chamadas recebidas",
      attributeDisplayType: "checkbox",
      attributeKey: "rejectCall",
      value: false,
      msgCall: '',
      category: "whatsapp",
    },
    {
      id: 2,
      attributeDisplayName: "Ignorar todas as mensagens de grupos",
      attributeDisplayType: "checkbox",
      attributeKey: "groupsIgnore",
      value: false,
      category: "whatsapp",
    },
    {
      id: 3,
      attributeDisplayName: "Mantenha o whatsapp sempre online",
      attributeDisplayType: "checkbox",
      attributeKey: "alwaysOnline",
      value: false,
      category: "whatsapp",
    },
    {
      id: 4,
      attributeDisplayName: "Marcar todas as mensagens como lidas",
      attributeDisplayType: "checkbox",
      attributeKey: "readMessages",
      value: false,
      category: "whatsapp",
    },
    {
      id: 5,
      attributeDisplayName: "Sincronize todo o histórico de bate-papo completo ao escanear o código QR",
      attributeDisplayType: "checkbox",
      attributeKey: "syncFullHistory",
      value: false,
      category: "whatsapp",
    },
    {
      id: 6,
      attributeDisplayName: "Marcar todos os status como lidos",
      attributeDisplayType: "checkbox",
      attributeKey: "readStatus",
      value: false,
      category: "whatsapp",
    },
    /* --- Chatwoot --- */
    {
      id: 7,
      attributeDisplayName: "Assinar mensagem com nome de usuário Cortexwoot",
      attributeDisplayType: "checkbox",
      attributeKey: "chatwootSignMsg",
      value: false,
      category: "chatwoot",
    },
    {
      id: 8,
      attributeDisplayName: "Reabrir conversa ao receber mensagem",
      attributeDisplayType: "checkbox",
      attributeKey: "chatwootReopenConversation",
      value: false,
      category: "chatwoot",
    },
    /*{
      id: 9,
      attributeDisplayName: "As conversas começam como pendentes",
      attributeDisplayType: "checkbox",
      attributeKey: "chatwootConversationPending",
      value: false,
      category: "chatwoot",
    },*/
    {
      id: 9,
      attributeDisplayName: "Importe contatos da agenda do WhatsApp conectando o QR Code",
      attributeDisplayType: "checkbox",
      attributeKey: "chatwootImportContacts",
      value: false,
      category: "chatwoot",
    },
    {
      id: 10,
      attributeDisplayName: "Se deve mesclar contatos de números brasileiros com e sem o 9 adicional",
      attributeDisplayType: "checkbox",
      attributeKey: "chatwootMergeBrazilContacts",
      value: false,
      category: "chatwoot",
    },
    {
      id: 11,
      attributeDisplayName: "Importe mensagens do WhatsApp conectando QR Code",
      attributeDisplayType: "checkbox",
      attributeKey: "importMessages",
      value: false,
      category: "chatwoot",
    },
    {
      id: 12,
      attributeDisplayName: "Limite de dias para importação de mensagens",
      attributeDisplayType: "number",
      attributeKey: "chatwootDaysLimitImportMessages",
      value: 7,
      category: "chatwoot",
    },
  ]);

  const whatsappAttributes = computed(() =>
    attributesWhatsapp.value.filter(attr => attr.category === 'whatsapp')
  );

  const chatwootAttributes = computed(() =>
    attributesWhatsapp.value.filter(attr => attr.category === 'chatwoot')
  );

  // Função para atualizar os atributos (opcional, caso queira encapsular essa lógica)
  const updateAttribute = ({ key, value, rejectionMessage }) => {
    const attribute = attributesWhatsapp.value.find(attr => attr.attributeKey === key);
    if (attribute) {
      attribute.value = value;

      if (rejectionMessage !== undefined && attribute.attributeKey === 'rejectCall') {
        attribute.msgCall = rejectionMessage;
      }
      // Forçar reatividade
      attributesWhatsapp.value = [...attributesWhatsapp.value];
    }
  };

  return {
    attributesWhatsapp,
    whatsappAttributes,
    chatwootAttributes,
    updateAttribute,
  };
}
